// Module
var code = "<div class=\"im-file\"> <div class=\"im-file-icon tooltip\"> <span class=\"tooltiptext\">发送文件</span> </div> <input class=\"im-file-choose\" type=\"file\"/> </div>";
// Exports
module.exports = code;